document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

function setGalleryImage(section, thumb) {
  const image = section.querySelector('[data-product-main-image]');
  if (!image) return;

  const src = thumb.getAttribute('data-media-src');
  const alt = thumb.getAttribute('data-media-alt');
  const mediaId = thumb.getAttribute('data-media-id');

  if (src) {
    image.src = src;
    image.removeAttribute('srcset');
  }
  if (alt) image.alt = alt;
  if (mediaId) image.setAttribute('data-media-id', mediaId);

  section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
  });
}

function setupProductForm(form) {
  const variantsElement = form.querySelector('[data-product-variants]');
  const variantSelect = form.querySelector('[data-variant-select]');
  const optionInputs = Array.from(form.querySelectorAll('[data-option-input]'));
  const section = form.closest('[data-product-section]');

  if (!variantsElement || !variantSelect || !section) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsElement.textContent);
  } catch (error) {
    return;
  }

  const selectedOptions = () => optionInputs
    .filter((input) => input.checked)
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
    .map((input) => input.value);

  const findSelectedVariant = () => {
    if (optionInputs.length === 0) {
      return variants.find((variant) => String(variant.id) === variantSelect.value);
    }

    const options = selectedOptions();
    return variants.find((variant) => variant.options.every((value, index) => value === options[index]));
  };

  const updateOptionAvailability = () => {
    if (optionInputs.length === 0) return;
    const currentOptions = selectedOptions();

    optionInputs.forEach((input) => {
      const optionIndex = Number(input.dataset.optionPosition) - 1;
      const candidateOptions = [...currentOptions];
      candidateOptions[optionIndex] = input.value;
      const available = variants.some((variant) => (
        variant.available && variant.options.every((value, index) => value === candidateOptions[index])
      ));

      input.disabled = !available;
      const label = form.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.toggle('is-unavailable', !available);
    });
  };

  const renderVariant = (variant) => {
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const submit = form.querySelector('[data-add-to-cart]');

    if (!variant) {
      if (submit) {
        submit.disabled = true;
        submit.textContent = submit.getAttribute('data-sold-out-label');
      }
      return;
    }

    variantSelect.value = String(variant.id);
    if (price) price.textContent = variant.price;

    if (comparePrice) {
      comparePrice.hidden = !variant.compare_at_price;
      comparePrice.textContent = variant.compare_at_price || '';
    }

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available
        ? submit.getAttribute('data-add-label')
        : submit.getAttribute('data-sold-out-label');
    }

    if (variant.featured_media_id) {
      const thumb = section.querySelector(`[data-gallery-thumb][data-media-id="${variant.featured_media_id}"]`);
      if (thumb) {
        setGalleryImage(section, thumb);
      } else if (variant.featured_media_src) {
        const image = section.querySelector('[data-product-main-image]');
        if (image) {
          image.src = variant.featured_media_src;
          image.removeAttribute('srcset');
          image.alt = variant.featured_media_alt || image.alt;
          image.setAttribute('data-media-id', String(variant.featured_media_id));
        }
        section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
          button.setAttribute('aria-current', 'false');
        });
      }
    }

    if (variant.url) window.history.replaceState({}, '', variant.url);
    updateOptionAvailability();
  };

  optionInputs.forEach((input) => {
    input.addEventListener('change', () => renderVariant(findSelectedVariant()));
  });

  variantSelect.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    renderVariant(variant);
  });

  renderVariant(findSelectedVariant());
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const open = !menu.hidden;
    menu.hidden = open;
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    return;
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (!thumb) return;
  const section = thumb.closest('[data-product-section]');
  if (section) setGalleryImage(section, thumb);
});

document.querySelectorAll('[data-product-form]').forEach(setupProductForm);
